import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { VerifySmfaService } from '../verify-smfa.service';
import { CreditSetupStatus, MobileStateService } from '@brightside-web/desktop/data-access/shared';
import { Router } from '@angular/router';
import { CreditSetupService } from '@brightside-web/desktop/data-access/credit';
import { BsCacheService } from '@brightside-web/desktop/data-access/core-services';
import { SimpleGlobalModalService } from 'libs/desktop/data-access/core-services/src/lib/GlobalModal/simple-global-modal.service';

@Component({
    selector: 'brightside-web-verify-smfa',
    templateUrl: './verify-smfa.component.html',
    styleUrls: ['./verify-smfa.component.scss'],
    providers: [VerifySmfaService],
    standalone: false
})
export class VerifySmfaComponent {
  sub: Subscription = new Subscription();
  linkExpired = false;
  smfaTimeTimeoutInMinutes: number;

  constructor(
    private verifySmfaService: VerifySmfaService,
    private creditSetupSvc: CreditSetupService,
    private _router: Router,
    private _mobileStateService: MobileStateService,
    private _modalService: SimpleGlobalModalService,
    private _bsCacheService: BsCacheService
  ) {
    this.getTimeoutInMinutes();
    this.sub.add(
      this.verifySmfaService.smfa.subscribe((smfaResult) => {
        if (smfaResult === CreditSetupStatus.VERIFIED) {
          this.verifySmfaService.stopPolling = true;
          this.creditSetupSvc.getSetupStatus();

          this._mobileStateService.get(true).subscribe(() => {
            this._bsCacheService.getItem('ONBOARDING_FLOW_ACTIVE').then((onboarding) => {
              if (onboarding) {
                this._modalService.createModal({
                  title: 'ONBOARDING_CREDIT_VERIFIED_SUCCESS_TITLE',
                  contentKey: 'ONBOARDING_CREDIT_VERIFIED_SUCCESS_DESC',
                  headerImagePath: './assets/thumbs-up.png',
                  displayCloseButton: false,
                  eventName: 'onboarding_credit_completed',
                  isError: false,
                  size: 'medium',
                  ctaKey: 'BUTTON_CONTINUE',
                  ctaAction: () => {
                    this.creditSetupSvc.creditSucceeded.set(true);
                  },
                });
                this._router.navigate(['onboarding']);
                return;
              }

              this._modalService.createModal({
                title: 'ONBOARDING_CREDIT_VERIFIED_SUCCESS_TITLE',
                contentKey: 'ONBOARDING_CREDIT_VERIFIED_SUCCESS_DESC',
                displayCloseButton: false,
                eventName: 'credit_ready_modal',
                isError: false,
                size: 'medium',
                ctaKey: 'GOT_IT',
                ctaAction: () => {
                  this._modalService.clearModal();
                },
              });

              this._router.navigate(['home']);
            });
          });
        } else if (smfaResult === CreditSetupStatus.VERIFY_SMFA_TIMEOUT) {
          this.linkExpired = true;
        }
      })
    );
    this.verifySmfaService.pollVerifySMFA();
  }

  requestText() {
    this.creditSetupSvc
      .blankPatchToCreditSub()
      .then((_) => {
        if (_.remainingSMFAAttempts && _.remainingSMFAAttempts !== 0) {
          this.linkExpired = false;
          this.verifySmfaService.pollVerifySMFA();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  routeUserOnBack() {
    this._router.navigate(['home']);
  }

  async getTimeoutInMinutes() {
    const smfaTimeTimeoutInMinutesFromState = this._router.currentNavigation()?.extras?.state?.smfaTimeTimeoutInMinutes;
    this.smfaTimeTimeoutInMinutes =
      (await this._bsCacheService.getItem('smfaTimeTimeoutInMinutes')) || smfaTimeTimeoutInMinutesFromState;
  }
}
